import React from 'react';
import PropTypes from 'prop-types';
import { PopoverBody } from 'reactstrap';

const PopoverMenu = props => (
  <PopoverBody role="menu" className="dots-actions__popover">
    <ul role="tooltip" className="list-group">
      {props.children}
    </ul>
  </PopoverBody>
);

PopoverMenu.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

export default PopoverMenu;
